<template>
	<div :class="`mb${gap}`">
		<core-files-card
			filesOf="case"
			:id="computedCaseId"
			:canWrite="canWrite"
			:list="files"
			@file:deleted="fetchFiles"
			@files:uploaded="fetchFiles"
		/>
	</div>
</template>

<script>
import CoreFilesCard from "@/modules/core/components/CoreFilesCard"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"
import { can } from "@/permissions/"

export default {
	components: { CoreFilesCard },
	props: {
		caseId: {
			type: String,
			default: ""
		},

		/**
		 * Vertical gap between fields
		 * It translates into mb{gap} class
		 */
		gap: {
			type: String,
			default: "4"
		}
	},

	data() {
		return {
			files: []
		}
	},

	computed: {
		computedCaseId() {
			return this.caseId ? this.caseId : this.$route.params.id
		},

		canWrite() {
			return can("writeFiles")
		}
	},

	methods: {
		async fetchFiles() {
			const query = gql`
				query fileListing($prefix: String) {
					list: fileListing(prefix: $prefix) {
						objectSummaries {
							fileName
							key
						}
						commonPrefixes
					}
				}
			`

			const res = await api({
				query,
				variables: { prefix: `case/${this.computedCaseId}/` }
			})

			this.files = res?.data?.list?.objectSummaries
		}
	},

	mounted() {
		this.fetchFiles()
	}
}
</script>
